import React, { Component } from 'react';
import './Footer.scss';
import LanguageService from './../../services/languageService'

class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const t  = LanguageService.texts ;
        const footer = LanguageService.getFooter();
        const { links, copyright } = footer;

        return (
            <div className="Footer">
                <div className="safety-disclaimer">
                    <p className="safety-label">{t.transactionSecured}</p>
                    <div className="template-logo"></div>
                </div>
                <div className="copyright">
                    <div className="copyright-container">
                        <p className="copyright-notice">© {copyright || (new Date().getFullYear() + ' Computop')} </p>
                        {links && (
                            <ul className="link-list">
                                {links.map(link => (
                                    <li key={link.href}>
                                        <a target="_blank" rel="noopener noreferrer" href={link.href}>{link.label}</a>
                                    </li>
                                ))}
                            </ul>
                        )}

                        {!links && (
                            <ul className="link-list">
                                <li>
                                    <a target="_blank" rel="noopener noreferrer" href="https://www.computop.com/uk/tos">Terms & Conditions</a>
                                </li>
                                <li>
                                    <a target="_blank" rel="noopener noreferrer" href="https://www.computop.com/uk/data-protection"> Data
                                        Privacy</a>
                                </li>
                                <li>
                                    <a target="_blank" rel="noopener noreferrer" href="https://www.computop.com/uk/about-us"> About Computop</a>
                                </li>
                            </ul>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js